import {styled} from '@mui/system'

export const PatientEnrollmentStyled = styled('div')(({theme}) => ({
  marginTop: theme.spacing(8),

  '.table-header': {
    margin: `${theme.spacing(10)} ${theme.spacing(5)}`
  },

  '.filters': {
    margin: `0 ${theme.spacing(5)} ${theme.spacing(5)}`,
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))
